import { FcsFlag } from "../unleash";

export const FlagsShipmentBanner = {
  banner_promo_create_shipment: new FcsFlag.JSONFlag({ content: [] }),
};

export function initFlagsShipmentBanner() {
  FcsFlag.register("website", FlagsShipmentBanner);
}
